import {useMemo} from 'react';
import PERMISSIONS from '@/config/permissions';
import {ContentLabSubscription} from '@/types/models/pricing/contentLabSubscription';
import {convertPlansDataToPlansCollections} from '@/views/content-studio/pricing/utils';
import getActiveSubscription from '@/views/content-studio/utils/getActiveSubscription';
import useCurrentSubscriptionQuery from '@/hooks/content-studio/use-current-subscription-query';
import useContentLabPlansQuery from '@/hooks/content-studio/use-plans-query/usePlansQuery';
import useDashboardUserPermissions from '@/hooks/use-dashboard-user-permissions';

export function useContentLabSubscriptionData() {
  const contentLabPermissions = useDashboardUserPermissions([
    PERMISSIONS.CONTENT_LAB.VIEW,
  ]);

  const isEnabled = Object.values(contentLabPermissions).every(Boolean);

  const {
    data: currentSubscriptions,
    isFetching: isFetchingCurrentSubscription,
    refetch: refetchCurrentSubscription,
  } = useCurrentSubscriptionQuery(isEnabled);

  const {plansData, isPlansDataFetched} = useContentLabPlansQuery(isEnabled);

  const activeSubscription: ContentLabSubscription | undefined =
    getActiveSubscription(currentSubscriptions?.subscriptions);

  const {plansCollections, activePlan} = useMemo(() => {
    return convertPlansDataToPlansCollections(
      plansData || [],
      activeSubscription?.plan
    );
  }, [plansData, currentSubscriptions]);

  return {
    activePlan,
    activeSubscription,
    plansCollections,
    isPlansDataFetched,
    isFetchingCurrentSubscription,
    refetchCurrentSubscription,
  };
}

export default useContentLabSubscriptionData;
